import axios from "axios";
const getServices2Api = async (
  callback,
  servicesResData,
  lang,
  baseURL,
  loading
) => {
  loading(true);
  try {
    const response = await axios.get(`${baseURL}/website/services2`, {
      headers: {
        Accept: "application/json",
        lang: lang,
      },
    });
    // console.log(data);
    servicesResData(response.data.sectionTitle);
    callback(response.data.data.data);
    loading(false);
    return;
  } catch (error) {
    loading(false);
    throw new Error(error);
  }
};

export default getServices2Api;
